module.exports = __webpack_public_path__ + "static/img/anxun82.cbad68ba.png";